<script>
import { AnswerStatus, busGetters, getCoupon, getCouponSetting } from 'dygc';
import { createPopup } from '../../assets/js/factory';
import HistoryCoupon from '../overlay/HistoryCoupon.vue';
import PhoneValidate from '../overlay/PhoneValidate.vue';
import CouponDescribe from './CouponDescribe.vue';

export default {
  name: "Coupon",
  components: { CouponDescribe },
  data() {
    return {
      validateDate: 0,
      validateTime: 0,
      couponRecord: null,
      hasCoupon: false,
      errorMessage: ""
    }
  },
  computed: {
    couponAmount() {
      const data = this.couponRecord
      if (!data) return 0
      return (data.amount) / 100
    },
    couponCode() {
      const data = this.couponRecord
      if (!data) return 0
      return data.remoteCouponCode
    },
    fromOtherAnswer() {
      const data = this.couponRecord
      if (!data) return false
      return data.fromOtherAnswer || this.$bus.answerId !== data.answerId
    },
    remainTimeText() {
      return this.formatTimeDifference(this.validateTime)
    },
    answerStatusIsOk() {
      return [AnswerStatus.OK, AnswerStatus.PASS].includes(this.status)
    },
    answerStatusIsHas() {
      return [AnswerStatus.ERR1].includes(this.status)
    },
    couponTips() {
      const data = this.couponRecord
      if (!data) return ""
      // switch (data.deviceType) {
      //   case "HENG_ZHONG_ICE":
      //     return "仅限冰淇淋机使用"
      //   case "HENG_ZHONG_SUGAR":
      //     return "仅限棉花糖机使用"
      // }
      return `仅限${data.deviceTypeText}使用`
    },
    status() {
      return this.overData?.status
    },
    couponStatusClass() {
      // :class="{ 'coupon-ygq': validateTime <= 0 ||  }"
      const data = this.couponRecord
      if (!data) return null
      return {
        'coupon-ygq': this.validateTime <= 0 || data.status == 2,
        "coupon-ysy": data.status == 1
      }
    },
    ...busGetters([
      'overData'
    ])
  },
  mounted() {
    this.getCoupon()
  },
  methods: {
    onShowHistory() {
      createPopup(HistoryCoupon, {
        userOpenId: this.$bus.params.accountUserOpenId
      })
    },
    onValidate() {
      createPopup(PhoneValidate, {
        title: "保存优惠券"
      })
    },
    getCoupon() {
      return getCouponSetting(this.$bus.survey.id).then(res => {
        if (!res.data.enable) {
          return
        }
        if (!this.$bus.params.accountUserOpenId) {
          return
        }
        if (!this.answerStatusIsOk) {
          this.hasCoupon = true
          return
        }
        return getCoupon(this.$bus.params.accountUserOpenId, this.$bus.survey.id, this.$bus.answerId).then(res => {
          this.hasCoupon = true

          if (!res.data) {
            if ([1, 2, 3].includes(res.code)) {
              this.errorMessage = "您已成功参与研酷的答题活动，但没有可以领的优惠券"
            } else if ([5, 7].includes(res.code)) {
              this.errorMessage = "您已成功参与研酷的答题活动，但没有可以领的优惠券"
            } else if ([4].includes(res.code)) {
              this.errorMessage = "您已成功参与研酷的答题活动，但不能再次获取新的优惠券。"
            } else if ([6].includes(res.code)) {
              this.errorMessage = "您已成功参与研酷的答题活动，但没有到达领取时间，请稍后再试。"
            } else {
              this.errorMessage = res.msg || "没有可领取的优惠卷"
            }
            return
          }

          this.couponRecord = res.data
          this.validateDate = res.data.validityTime
          const systemTime = res.data.systemTime
          const validityTime = res.data.validityTime
          this.validateTime = Math.max(((new Date(validityTime.replace(" ", "T")) - new Date(systemTime.replace(" ", "T"))) / 1000) | 0, 0)
          if (!this.validateTime) {
            return
          }
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            this.validateTime = this.validateTime - 1
            if (this.validateTime <= 0) {
              clearInterval(this.timer)
            }
          }, 1000)
        })
      })

    },
    formatTimeDifference(seconds) {

      const days = Math.floor(seconds / (24 * 3600))
      seconds %= (24 * 3600)

      const hours = Math.floor(seconds / 3600)
      seconds %= 3600

      const minutes = Math.floor(seconds / 60)
      seconds %= 60
      const results = []
      if (days) {
        results.push(`${days}天`)
      }
      results.push(`${hours}小时${minutes}分钟${seconds}秒`)
      return results.join("")
    }
  }
}
</script>

<template>
  <Transition name="fade">
    <div v-if="hasCoupon" class="coupon">
      <div class="coupon-wrapper mb-3">
        <div class="coupon-tips mb-3">
          <template v-if="answerStatusIsHas || fromOtherAnswer">
            <div class="text-black text-left">
              您已成功参与研酷的答题活动，但不能再次获取新的优惠券。
            </div>
          </template>
          <template v-else-if="!answerStatusIsOk">
            <div class="text-black text-left">您未成功完成所有研酷的答题活动或被甄别题甄别，无法获得系统奖励的优惠券。</div>
          </template>
          <template v-else-if="errorMessage">
            <div class="text-black text-left">{{ errorMessage }}</div>
          </template>
          <template v-else>
            <div class="text-black text-center">您已成功参与研酷的答题活动</div>
          </template>
        </div>
        <div class="px-6" v-if="answerStatusIsOk && !answerStatusIsHas && !fromOtherAnswer && !errorMessage">
          <div class="line"></div>
        </div>
        <div class="coupon-content mt-5">
          <div v-if="answerStatusIsOk && !answerStatusIsHas && !fromOtherAnswer && !errorMessage">
            <template v-if="couponCode">
              <div class="coupon-content__title coupon-status" :class="couponStatusClass">
                <span>您的优惠码</span>
              </div>
              <div class="text-theme-black-450 text-center text-small mt-1">{{ couponTips }}</div>

              <div class="coupon-content__code">
                <!-- <span class="mr-4">{{couponCode}}</span> -->
                <span>{{ couponCode }}</span>
              </div>
            </template>
            <template v-else>
              <div class="coupon-content__title coupon-status" :class="couponStatusClass">
                <span>研酷设备上扫码支付后，自动使用优惠卷</span>
              </div>
            </template>
            <div class="coupon-content__award-info">
              <div>
                <div>
                  <span>¥</span>
                  <span>{{ couponAmount }}</span>
                </div>
                <div class="split-line"></div>
                <div>
                  <div>全场可用</div>
                </div>
              </div>
            </div>
            <div class="coupon-content__time mt-5">
              <div>
                <span>优惠码有效期至：</span>
                <span>{{ validateDate }}</span>
              </div>
              <div>
                <span>剩余时间：</span>
                <span style="color: #F92A18;">{{ remainTimeText }}</span>
              </div>
            </div>
            <!-- <div class="mt-5 mb-5 text-center">
            <van-button color="#F92A18" size="small" style="width: 176px;" round @click="onValidate">保存</van-button>
          </div> -->
            <div class="mt-5 flex items-center justify-center history-text">
              <div class="flex items-center" @click="onShowHistory">
                <span>历史优惠券</span>
                <img src="~@/assets/img/answer/chevron-right-double.png" width="16">
              </div>
            </div>

          </div>
          <div v-else>
            <div class="text-black text-medium">
              请点击查看“历史优惠券”功能，是否有已经领取的优惠券。
            </div>
            <div class="mt-5 text-center">
              <van-button color="#F92A18" size="small" style="width: 176px;" round
                @click="onShowHistory">历史优惠券</van-button>
            </div>
          </div>
        </div>
      </div>
      <CouponDescribe />
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.coupon {
  // padding: 12px;
  // background-image: linear-gradient(180deg, #FFFFFF 0%, #FFF7F7 98%);


  &-wrapper {
    background-image: linear-gradient(180deg, #FFFFFF 0%, #FFF7F7 98%);
    border-radius: 16px;
    overflow: hidden;
  }

  &-tips {
    background-image: linear-gradient(180deg, #FFD5D5 0%, #ffffff00 98%);
    font-size: 14px;
    color: #F92A18;
    text-align: center;
    line-height: 22px;
    padding: 20px 24px 8px;
  }

  &-content {
    padding: 0 24px 24px;
  }

  .coupon-content {
    &__title {
      font-weight: 600;
      font-size: 18px;
      color: rgba($color: #000000, $alpha: 0.9);
      text-align: center;
    }

    &__code {
      background: #EEF0F5;
      border-radius: 8px;
      font-weight: 600;
      font-size: 44px;
      color: #000000e6;
      letter-spacing: 4px;
      text-align: center;
      line-height: 52px;
      padding: 12px 0;
      margin-top: 10px;
    }

    &__time {
      font-weight: 400;
      font-size: 14px;
      color: rgba($color: #000000, $alpha: 0.9);
      line-height: 22px;
    }

    &__award-info {
      width: 303px;
      height: 66px;
      background-image: url("~@/assets/img/answer/coupon/coupon-bg.png");
      background-repeat: no-repeat;
      background-size: contain;
      margin-top: 16px;

      &>div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 244px;
        padding: 3px 30px;
        box-sizing: border-box;

        &>div {
          &:first-child {
            font-weight: 600;
            color: #F92A18;
            text-align: center;
            line-height: 52px;

            span {
              &:last-child {
                font-size: 38px;
              }
            }
          }

          &:last-child {
            width: 90px;
            height: 24px;
            background: #FFC65A;
            border: 1px solid #FBB735;
            border-radius: 15px;

            font-size: 14px;
            color: #E21700;
            text-align: center;
            line-height: 24px;
          }
        }

        .split-line {
          width: 1px;
          height: 29px;
          border-right: 1px dashed #F92A18;
        }
      }


    }

    .history-text {
      font-size: 14px;
      color: #F92A18;
      text-align: center;
      line-height: 22px;
    }
  }
}

.line {
  border-bottom: 2px dashed #e7e9eb;
  position: relative;

  &::before,
  &::after {
    content: ' ';
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    // background-color: #fff;
  }

  &::before {
    left: -24px;
  }

  &::after {
    right: -24px;
  }
}

.coupon-status {
  position: relative;

  &::after {
    content: " ";
    position: absolute;
    right: 0;
    background-image: url("~@/assets/img/answer/coupon/wgq.png");
    width: 60px;
    height: 48px;
    background-repeat: no-repeat;
    background-size: contain;
    top: -16px;
  }

  &.coupon-ygq {
    &::after {
      background-image: url("~@/assets/img/answer/coupon/ygq.png");
    }
  }

  &.coupon-ysy {
    &::after {
      background-image: url("~@/assets/img/answer/coupon/ysy.png");
    }
  }
}
</style>